import React, { useState, useEffect, useRef } from "react";
import DataTable from "../../../../Components/UiComponents/DataTable";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import "react-toastify/dist/ReactToastify.css";
import { InputIcon } from "primereact/inputicon";
import _ from "lodash";

// Components
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import Loader from "../../../../Components/UiComponents/Loader";
import SingleSelectElement from "../../../../Components/UiComponents/SingleSelectElement";
import PlaylistVideos from "../../../../Components/Videos/PlaylistVideos";
import { Dialog } from "primereact/dialog";

// Services
import {
  get,
  getPendingUsers,
  getCustBranch,
  getCustomerControlField,
  sendPendingMails,
} from "../../../../Services/customerServices";
import { useNavigate } from "react-router-dom";

export default function Outbox(props) {
  const [customerId, setCustomerId] = useState(null);
  const [branch, setBranch] = useState(null);
  const [custmerReferenceData, setCustmerReferenceData] = useState([]);
  const [customerControlFields, setCustomerControlFields] = useState(null);
  const toast = useRef(null);
  const [promptTabs, setPromptTabs] = useState([]);
  const toastRef = useRef();
  const [loading, setLoading] = useState(false);
  const [branches, setBranches] = useState([]);
  const [showBranch, setShowBranch] = useState(false);
  const [cust_name, setCust_name] = useState("");
  const [selectionFilter, setSelectionFilter] = useState(null);
  const [dataToDelete, setDataToDelete] = useState([]);
  const [deleted, setDeleted] = useState(false)
  const [showVideo, setShowVideo] = useState(false);
  const navigate = useNavigate()

  useEffect(() => {
    // Fetching end user data from local storage
    const enduserStr = localStorage.getItem("enduser");
    // Checking if end user data exists in local storage
    if (enduserStr) {
      // Parsing end user data
      const enduser = JSON.parse(enduserStr);
      // Extracting customer information from end user data
      const customer = enduser.customer;
      // Setting customer ID state
      setCustomerId(customer);
      setBranch(enduser.branch);
    } else {
      // Logging if no end user data found in local storage
      navigate("/login")
      localStorage.clear()
    }
  }, []);

  useEffect(() => {
    // Fetching customer field data
    // Fetching customer control data
    getCustomerControl();
    getCustomer();
  }, [customerId]);

  useEffect(() => {
    if (selectionFilter) {
      handleSelectionFilter();
    }
  }, [selectionFilter]);

  useEffect(() => {
    if (deleted) {
      setDeleted(false);
      setDataToDelete([]);
    }
  }, [deleted])

  // Function to get customer reference data.
  const getCustomer = async () => {
    try {
      if (customerId === null) {
        return;
      }
      setLoading(true)
      if (customerId) {
        const customer = await get(customerId);
        if (customer) {
          setCust_name(customer.data?.customer_name);
          if (customer && customer.data?.havingBranch) {
            setShowBranch(true)
            const branch = await getCustBranch(customerId);
            if (branch) {
              const allBranches = branch.data;
              setBranches(allBranches);
            }
          } else {
            var currentFlag = 'customer';
            getPendingUsersList(customer.data._id, currentFlag);
          }
        }
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      setLoading(false)
    }
  };

  const getPendingUsersList = async (cust_id, flag) => {
    try {
      const getusersbybranch = await getPendingUsers(
        cust_id,
        flag
      );
      setCustmerReferenceData(getusersbybranch?.data);
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    }
  }

  // Function to fetch and set customer control fields data
  const getCustomerControl = async () => {
    try {
      if (customerId === null) {
        return;
      }
      // Check if customerId is available
      if (customerId !== null) {
        // Fetch customer control field data
        const customerData = await getCustomerControlField(customerId);
        // Extract and set customer control fields
        const controlFields = customerData?.data?.cust[0].modules[0];
        const promptTabs = controlFields.tabs.filter(
          (tab) => tab.tab_name === "Outbox"
        );
        setPromptTabs(promptTabs[0].tables[0].headers);
        setCustomerControlFields(controlFields);
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    }
  };

  const checkingFirstname = (rowData) => {
    return (
      <div>
        {
          <div>
            {rowData.firstname != null && rowData.firstname != ""
              ? rowData.firstname
              : rowData.firstname}
          </div>
        }
      </div>
    );
  };
  const checkingSurname = (rowData) => {
    return <div>{<div>{rowData.surname}</div>}</div>;
  };
  const checkingUsername = (rowData) => {
    return <div>{<div>{rowData.username}</div>}</div>;
  };
  const checkingRolename = (rowData) => {
    return <div>{<div>{rowData.role_name}</div>}</div>;
  };
  const checkingEmail = (rowData) => {
    return <div>{<div>{rowData.email}</div>}</div>;
  };
  const checkingStatus = (rowData) => {
    return <div>{<div>{rowData.status}</div>}</div>;
  };

  // Define column configuration for the data table
  const columns = [
    {
      field: "username", // Field name for the column data
      header: _.find(promptTabs, { header_name: "Username" })?.display_name,
      body: checkingUsername, // Function to render the cell content for this column
      // style: { width: "30%" }, // Inline style for the column
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "firstname",
      header: _.find(promptTabs, { header_name: "Firstname" })?.display_name,
      body: checkingFirstname,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "surname",
      header: _.find(promptTabs, { header_name: "Surname" })?.display_name,
      body: checkingSurname,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "rolename",
      header: _.find(promptTabs, { header_name: "Role" })?.display_name,
      body: checkingRolename,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "email",
      header: _.find(promptTabs, { header_name: "Email" })?.display_name,
      body: checkingEmail,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "status",
      header: _.find(promptTabs, { header_name: "Status" })?.display_name,
      body: checkingStatus,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
  ];

  const handleSelectionFilter = async () => {
    const currentFlag = "branch";
    try {
      setLoading(true);
      const getusersbybranch = await getPendingUsers(
        selectionFilter._id,
        currentFlag
      );
      setCustmerReferenceData(getusersbybranch?.data);
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      setLoading(false)
    }
  };

  const sendPendingEmail = async () => {
    if (dataToDelete.length > 0) {
      let idsArray = [];
      // Extract ids using forEach
      dataToDelete?.forEach(function (item) {
        idsArray.push({ id: item._id });
      });
      try {
        setLoading(true);
        const response = await sendPendingMails(cust_name, idsArray);
        if (
          response && response?.status === 200 &&
          response?.data?.message === "Mail(s) are successfully sent"
        ) {
          toastRef.current.showToast({
            type: "success",
            message: `${response?.data?.message} `,
          });
          setDeleted(true)
        } else {
          toastRef.current.showToast({
            type: "error",
            message: "Error in sending mails",
          });
          setDeleted(true)
        }
        var currentFlag = 'customer';
        var enduser = localStorage.getItem("enduser")
        if (enduser) {
          var tmpData = JSON.parse(enduser);
          if (tmpData) {
            getPendingUsersList(tmpData.customer, currentFlag);
          } else {
            navigate("/login")
            localStorage.clear()
          }
        }
      } catch (error) {
        toastRef.current.showToast({
          type: 'error',
          message: 'An error occurred. Please try again or Contact Admin.'
        });
      } finally {
        setLoading(false)
      }
    } else {
      toastRef.current.showToast({
        type: "error",
        message: "Select at least one",
      });
    }
  };

  const removeField = async (selectedIndex, data) => {
    setDataToDelete(data);
  };

  const handleButtonClick = () => {
    setShowVideo(true);
  };

  const closeVideo = () => {
    setShowVideo(false);
  };

  return (
    <div className="group-table-component">
      <ToastElement ref={toastRef} />
      <Loader loading={loading} />
      <div className="header-design">
        <div>
          <p className="fs-16 fw-600 mar-b-3">
            {
              _.find(customerControlFields?.tabs, { tab_name: "Outbox" })
                ?.display_name + ' - ' +
              _.find(customerControlFields?.tabs, { tab_name: "Outbox" })
                ?.tables[0]?.display_name
            }
          </p>
        </div>
        <div className="group-table-buttons m-0">
          <div className="delete-button"></div>
          {
            showBranch &&
            <div className="group-table-search">
              <div className="col pr-0">
                <div className="branch-container">
                  <span className="form-label text-left">Branch:&nbsp;</span>
                  <SingleSelectElement
                    value={selectionFilter}
                    optionLabel="branch_name"
                    options={(branches != undefined && branches.length > 0) ? branches : []}
                    placeholder="-- Please select --"
                    maxSelectedLabels={1}
                    onChangeValue={(e) => { setSelectionFilter(e.target.value); }}
                    className="usage-filter"
                  />
                  <div>
                    <ButtonElement className="upload-button ml-2" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
      <div className="mt-10">
        <DataTable
          value={custmerReferenceData}
          columns={columns}
          isNotReorder={true}
          dataKey="_id"
          removeField={removeField}
          deleted={deleted}
        />
      </div>
      {
        custmerReferenceData.length > 0 &&
        <div className="col pr-0 d-flex justify-end">
          <ButtonElement
            className="save-button"
            type="submit"
            onClick={sendPendingEmail}
            label="Send"
          />
        </div>
      }
      <Dialog id="videoModal" visible={showVideo}
        breakpoints={{
          '1200px': '80vw',    // Larger modal on bigger screens
          '1024px': '85vw',    // Slightly smaller for medium screens
          '769': '90vw',     // Responsive on tablets
          '641px': '95vw',     // Almost full-width on mobile
        }}
        modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
      >
        <div className="video-overlay">
          <div className="video-container">
            <PlaylistVideos playlistId={process.env.REACT_APP_CONTROL_PANEL_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="control_panel_outbox" />
          </div>
        </div>
      </Dialog>
    </div>
  );
}
